export { default } from './NewsTypeSelect';
